import { ReactNode, memo, useState, useEffect } from 'react';
import { Span } from '../../../../component/modal/ModalStyle';
import Modal from '../../../../component/modal/Modal.component';
import Button from '../../../../component/buttton/Button.component';
import GridComponent from "../../../../component/grid/GridComponent.component";
import MenuItem from '@material-ui/core/MenuItem';
import { FormSelect } from '../../../../component/input/InputStyle';
import {useManagement} from '../../../../context/Management';
import { getUser } from '../../../../core/auth/auth';
import { getCd } from '../../cards/separations/Separations.service';
import { ModalInterface } from '../../cards/separations/interface/SeparationsInterface';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from '../../../../context/Snackbar';

interface Props {
    children?: ReactNode;
    open: boolean;
    onClickSubmit(): void;
    title: string;
}

function ModalMenuManagement({ open, title, onClickSubmit}: Props) {

    const { setSnackbar } = useSnackbar();
    const {valueCd, setValueCd, setSeparations} = useManagement();
    const [cd, setCd] = useState<ModalInterface[]>([]);
    const [loading, setLoading] = useState(Boolean)

    const getCD = async () => {
        try {
            setLoading(true);
            const resUser = getUser();
            const resUserUpperCase = resUser.sAMAccountName.toLocaleUpperCase();
            const res = await getCd(resUserUpperCase);
            setCd(res.data);
            setLoading(false)
        } catch(error) {
            setLoading(false);
            console.log(error);
            setSnackbar({msg: 'Erro na comunicação com a API.', subMsg: 'Verifique com a equipe de TI as suas permissões.', type: 'error'})
        }
    } 
    
    const handleChange = (event: any) => {
        const {value} = event.target;
        setValueCd(value);
        setSeparations(value);
    }

    useEffect(() => {
        if(open === true) {
            getCD();   
        }
    }, [open]);

        return (
            <Modal open={open} handleClick={() => {}} >
                <Span style={{textAlign:"center"}}>{title.toLocaleUpperCase()}</Span>
                <GridComponent margin="10px auto 10px auto" spacing={2}>
                    <FormSelect onChange={handleChange} value={valueCd} displayEmpty={true} defaultValue={""}>
                        <MenuItem disabled value="">Selecione</MenuItem>
                            {cd.map((item: ModalInterface, id: number) => (
                                <MenuItem key={id} value={item.id}>{item.id}</MenuItem>
                            ))}
                    </FormSelect>
                        {loading ? <Button disabled NoReload={true} title='Aguarde' icon={<CircularProgress size={20} color='inherit' />} size='medium' margin='20px auto' onClick={onClickSubmit} /> : <Button title='Selecionar' size='medium' margin='20px auto' onClick={onClickSubmit} />}
                </GridComponent>
            </Modal>
        );
}

export default memo(ModalMenuManagement);